module.exports = {
	"questions": [
		{
			"question": "WHAT IS AN OFFER?",
			"answer": "Stores located at NEX Outlets offer sales, coupons, and special promotions to shoppers. The offers listed in the app show you what is available now."
		},
		{
			"question": "WHAT IF I'M HAVING TROUBLE FINDING AN OFFER FOR A PARTICULAR STORE?",
			"answer": "Offers change frequently. They can run for hours or weeks. If you can’t find an offer for a store, be sure to check back soon."
		},
		{
			"question": "HOW CAN I REDEEM AN OFFER?",
			"answer": "To redeem an offer, tap on the offer in question, tap the redeem button (if present), and review the instructions. Instructions may include a unique code, a QR code, or details for the sales associate. Every offer will have details and instructions available. Please visit the NEX Management Office or contact info@nexoutlets.com if you have any questions or problems."
		},
		{
			"question": "WHO DO I CONTACT IF I HAVE A QUESTION?",
			"answer": "All questions and feedback should be directed to the NEX Management Office (located in the interior hallway between kate spade and Michael Kors) or via email at info@nexoutlets.com"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/frequently_asked_questions.json
// module id = 138
// module chunks = 0